import { ReactNode } from 'react';

interface PortfolioShellProps {
  children: ReactNode;
}

const PortfolioShell = ({ children }: PortfolioShellProps) => {
  return (
    <div className="flex min-h-0 flex-col bg-background bg-[image:var(--nq-canvas-glow)] text-foreground">
      <main className="mx-auto box-border w-full max-w-[1440px] flex-1 px-7 pb-10 pt-6">
        {children}
      </main>
    </div>
  );
};

export default PortfolioShell;
